/**
 * /component/service/index.js
 */

import React from 'react';
import Grid from 'material-ui/Grid';
import ServiceItem from './ServiceItem';
import PAGE_CONFIG from '../../config/service.json';
import Helmet from "../Helmet";
import { initGA } from '../GA'; 

class Service extends React.Component{
  
  componentDidMount(){
    initGA();
  }
  render(){
    return (
      <div className="center-container">
        <Helmet title={PAGE_CONFIG.title} description={PAGE_CONFIG.description} canonical={PAGE_CONFIG.canonical} />
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <div className="contents-title-cont">
              <h1 className="contents-title">{PAGE_CONFIG.title}</h1>
              <p className="contents-sub-title">{PAGE_CONFIG.sub_title}</p>
            </div>
            <div className="animation-contaiter service-container">
              <ServiceItem {...PAGE_CONFIG} />
            </div>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default Service;


// WEBPACK FOOTER //
// ./src/component/service/index.js